import { post } from "../../api/HttpClient.js";
import { BASE_URL, MeetingRoomsAvailableAndBookings_url } from "../../config/ApiConfig.js";
import { AppConstant } from "../../config/AppConstants.js";

// Meeting rooms are SpotType 3 (same value NewMeetingModal sends).
export const MEETING_ROOM_SPOT_TYPE = 3;
// ZoneId "0" asks the endpoint for every zone — this is the "All meeting rooms" view.
export const ALL_ZONES_ID = "0";

// Every meeting room across all zones for one date, plus the signed-in user's
// own meetings (`Bookings[]`). GuId is added by HttpClient.post.
export const MeetingRoomsAvailableAndBookings_api = ({ BookingDate }) =>
    post({
        url: `${BASE_URL}${MeetingRoomsAvailableAndBookings_url}`,
        params: {
            BookingDate,
            ZoneId: ALL_ZONES_ID,
            SpotType: MEETING_ROOM_SPOT_TYPE,
            AppVersion: AppConstant.AppVersion,
            Language: AppConstant.Language,
            DeviceId: AppConstant.DeviceID,
            OsVersion: AppConstant.OsVersion,
            ManufactureModel: AppConstant.ManufactureModel,
        },
    });
